<template>
  <div class="c-keyboard" v-visible="!loading">
    <img class="background" :src="images.keyboard_65_fluffy1" @load="onLoad" />
    <div class="keys2">
      <c-key
        v-for="(srcKey, index) in srcKeys"
        class="key"
        :class="{
          selected: selectedIndex === index,
          changed: !disabled && false,
          disabled: srcKey.disabled,
        }"
        :key="'srcKey' + index"
        :style="srcKey.style"
        :selected="selectedIndex === index"
        :profile="profile65Mecha"
        :layer="layer"
        :allKeys="allKeys"
        :dstKeys="dstKeys"
        :srcKey="srcKey"
        @click="
          !srcKey.disabled &&
            $emit('key-click', { index, keyIndex: srcKey.index })
        "
        @dblclick="
          !srcKey.disabled &&
            $emit('key-click', { index, keyIndex: srcKey.index })
        "
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { srcKeys, dstKeys } from "./Keyboard65Mecha";
import { allKeys } from "./VirtualKeyboard65Mecha";
import { deepCopy } from "@/utils";

export default {
  name: "CKeyboard65Mecha",
  props: {
    disabled: Boolean,
    selectedIndex: Number,
    layer: Array,
    layerIndex: Number,
  },
  data() {
    return {
      loading: true,
      srcKeys: deepCopy(srcKeys),
      dstKeys: deepCopy(dstKeys),
      allKeys,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile65Mecha"]),
  },
  watch: {
    layerIndex(layerIndex) {
      if (layerIndex === 1) {
        this.srcKeys[0] = {
          ...srcKeys[0],
          disabled: true,
        };
        // this.srcKeys[20] = {
        //   ...srcKeys[20],
        //   disabled: true,
        // };
      } else {
        this.srcKeys[0] = { ...srcKeys[0] };
        // this.srcKeys[20] = { ...srcKeys[20] };
      }
    },
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-keyboard {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .keys {
    width: 66.4%;
    height: 53%;
    position: absolute;
    left: 17%;
    top: 28.5%;
    display: flex;
    flex-wrap: wrap;

    .key {
      width: 4%;
      height: 15.5%;
      padding: 0 0.2%;
      font-size: 24px;
      color: #000000;
    }
  }

  .keys2 {
    width: 67.4%;
    height: 54%;
    left: 16.5%;
    top: 22.5%;
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    .key {
      width: 4%;
      height: 15.5%;
      padding: 0 0.2%;
      font-size: 24px;
      color: #000000;
    }
  }
}
</style>
